import { AccountPage } from '@gig/magic-account-types';

export const AccountPageNames = {
    CLOSURE: AccountPage.CLOSURE,
    MARKETING_PREFS: AccountPage.MARKETING_PREFS,
    PROFILE: AccountPage.PROFILE,
    RESPONSIBLE_GAMING: AccountPage.RESPONSIBLE_GAMING,
    SOURCE_OF_WEALTH: AccountPage.SOURCE_OF_WEALTH,
    VERIFICATION: AccountPage.VERIFICATION,
    QUESTIONNAIRES: AccountPage.QUESTIONNAIRES,
};

export const SIGN_UP_FORM_STEPS_QUERY = 'SIGN_UP_FORM_STEPS';

export const getAccountComponent =
    (component: keyof typeof import('./account.chunk')) => async () => {
        const chunk = await import(
            /* webpackChunkName: "account" */
            './account.chunk'
        );
        return chunk[component];
    };

export const getRGPComponent =
    (component: keyof typeof import('./responsible-gaming.chunk')) =>
    async () => {
        const chunk = await import(
            /* webpackChunkName: "responsible-gaming" */
            './responsible-gaming.chunk'
        );
        return chunk[component];
    };

export const getONJNComponent =
    (component: keyof typeof import('./onjn.chunk')) => async () => {
        const chunk = await import(
            /* webpackChunkName: "onjn" */
            './onjn.chunk'
        );
        return chunk[component];
    };

export const getAGCOComponent =
    (component: keyof typeof import('./agco.chunk')) => async () => {
        const chunk = await import(
            /* webpackChunkName: "agco" */
            './agco.chunk'
        );
        return chunk[component];
    };
